import React from "react";
import { useTranslation } from "react-i18next";

const PortalContent = () => {
  const { t , i18n} = useTranslation()

  return (
    <div className="content px-4">
      <p>Managed & Supported</p>
      <h3 className="uppercase">{t("Our portal")}</h3>
      <p className="mt-2">
    
          {t("Collaboration should be simple, transparent, and efficient. That’s why we provide you with our client portal a dedicated space where you can track project progress, review milestones, share feedback, and access all important files in one place. With real-time communication and full visibility, you’ll always stay connected to our team and confident in every step of the process.")}
      </p>
    </div>
  );
};

export default PortalContent;
